import React from "react"


const NotFoundPage = () => {
    return (
        <div className="layout-center">
            <div className="error-container">
                <div className="error-code">
                    <span>4</span>
                    <span>0</span>
                    <span>4</span>
                </div>
                <p>Ми не змогли знайти таку сторінку</p>
            </div>
        </div>
    )
}

export default NotFoundPage
